import React from 'react';

const ModeratorIcon = () => (
  <svg className='user-icon' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='2' fill='#3DC573' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.00001 13C11.0972 13 13.7245 9.791 14.647 8.51461C14.8716 8.20394 14.8716 7.79606 14.647 7.48539C13.7245 6.209 11.0972 3 8.00001 3C4.90287 3 2.27552 6.209 1.35298 7.48539C1.12843 7.79606 1.12843 8.20394 1.35298 8.51461C2.27552 9.791 4.90287 13 8.00001 13ZM8.00001 12C10.2092 12 12 10.2091 12 8C12 5.79086 10.2092 4 8.00001 4C5.79087 4 4.00001 5.79086 4.00001 8C4.00001 10.2091 5.79087 12 8.00001 12Z'
      fill='white'
    />
    <circle cx='8' cy='8' r='2' fill='white' />
  </svg>
);

export default ModeratorIcon;
